import React, { Component } from "react";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { CellRender, GridNoRecord } from "../../../../Shared/GridComponents/CommonComponents";
import { currencyFormatter } from "../../../../../HelperMethods";
import { toODataString } from "@progress/kendo-data-query";
import { KendoFilter } from "../../../../ReusableComponents";
import { DetailColumnCell, ViewMoreComponent } from "./GlobalActions";
import axios from "axios";
import { LocalizationResource } from "../../../../Shared/AppConstants";
import { LocalizationHelper } from "../../../../../Localization/helpers/LocalizationHelper";

export interface RateCardHistoryProps {
    dataItem: any;
    handleClose: any;
}

let initialDataState = {
    skip: 0,
    take: 5,
    filter: undefined,
};

export interface RateCardHistoryState {
    data: any;
    totalCount?: number;
    filter: undefined;
    dataState?: any;
    showLoader?: boolean;
}

export default class RateCardHistory extends Component<RateCardHistoryProps, RateCardHistoryState> {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            filter: undefined,
            dataState: initialDataState,
            showLoader: true,
        };
    }

    componentDidMount() {
        this.getRatesHistory(this.state.dataState, this.props.dataItem);
    }

    getRatesHistory = (dataState, dataItem) => {
        var validFrom = dataItem.validFrom.substring(0, 10);
        this.setState({ showLoader: true });
        var queryStr = `${toODataString(dataState)}`;
        let queryParams = `clientId eq ${dataItem.clientId} and divisionId eq ${dataItem.divisionId} and locationId eq ${dataItem.locationId} and clientPosId eq ${dataItem.clientPosId} and serviceTypeId eq ${dataItem.serviceTypeId} and billTypeId eq ${dataItem.billTypeId} and validTo lt ${validFrom} and validTo ne null&$orderby=validFrom desc`;
        var finalQueryString = KendoFilter(dataState, queryStr, queryParams);

        axios.get(`api/admin/ratecards?${`$count=true&`}${finalQueryString}`).then((res) => {
            this.setState({
                data: res.data.items,
                showLoader: false,
                dataState: dataState,
                totalCount: res.data.count
            });
        });
    }

    expandChange = (dataItem) => {
        const { data } = this.state;
        const rateCardData = data.map((item) => {
            if (item === dataItem) {
                item.expanded = !item.expanded;
            }
            return item;
        });

        this.setState({
            data: rateCardData
        });
    };

    ExpandCell = (props) => <DetailColumnCell {...props} expandChange={this.expandChange.bind(this)} />;

    onDataStateChange = (changeEvent) => {
        this.getRatesHistory(changeEvent.dataState, this.props.dataItem);
    };

    render() {
        return (
            <div>
                <div className="containerDialog">
                    <div className="containerDialog-animation">
                        <div className="col-10 col-md-10 shadow containerDialoginside containerDialoginside-height">
                            <div className="row blue-accordion">
                                <div className="col-12  pt-2 pb-2 fontFifteen">
                                    Rate History
                                    <span className="float-right cursorElement" onClick={() => this.props.handleClose()}>
                                        <FontAwesomeIcon icon={faTimes} className="mr-1" />
                                    </span>
                                </div>
                            </div>
                            <div className="row ml-0 mr-0 mt-2 mb-2 mt-lg-3 mb-lg-3">
                                <Grid
                                    style={{ height: "auto" }}
                                    onDataStateChange={this.onDataStateChange}
                                    pageable={{ pageSizes: true }}
                                    pageSize={5}
                                    data={this.state.data}
                                    {...this.state.dataState}
                                    detail={ViewMoreComponent}
                                    expandField="expanded"
                                    total={this.state.totalCount}
                                    filterable={false}
                                    sortable={false}
                                    className="kendo-grid-custom k-widget lastchild"
                                >
                                    <GridNoRecords>{GridNoRecord(this.state.showLoader, true)}</GridNoRecords>
                                    <GridColumn
                                        field="region"
                                        width={100}
                                        title="Region"
                                        cell={(props) => CellRender(props, "Region")}
                                    />
                                    <GridColumn
                                        field="division"
                                        title="Division"
                                        cell={(props) => CellRender(props, "Division")}
                                        filter="text"
                                        filterable={false}
                                        sortable={false}
                                    />
                                    <GridColumn
                                        field="location"
                                        title={LocalizationHelper.getLocalizedTitle(LocalizationResource.Location_Label, "Location")}
                                        cell={(props) => CellRender(props, "Location")}
                                        filter="text"
                                        filterable={false}
                                        sortable={false}
                                    />
                                    <GridColumn
                                        field="position"
                                        title="Position"
                                        cell={(props) => CellRender(props, "Position")}
                                        filter="text"
                                        filterable={false}
                                        sortable={false}
                                    />
                                    <GridColumn
                                        field="serviceType"
                                        title="Service Type"
                                        cell={(props) => CellRender(props, "Service Type")}
                                        filter="text"
                                        width="130px"
                                        filterable={false}
                                        sortable={false}
                                    />
                                    <GridColumn
                                        field="billType"
                                        title="Bill Type"
                                        cell={(props) => CellRender(props, "Bill Type")}
                                        filter="text"
                                        width="80px"
                                        filterable={false}
                                        sortable={false}
                                    />
                                    <GridColumn
                                        field="maxBillRate"
                                        title="Max Bill Rate"
                                        headerClassName="text-right"
                                        cell={(props) => {
                                            return (
                                                <td contextMenu="Max Bill Rate"
                                                    className="pr-4 text-right"
                                                    title={props.dataItem.maxBillRate}
                                                >
                                                    {currencyFormatter(props.dataItem.maxBillRate)}
                                                </td>
                                            );
                                        }}
                                        width="90px"
                                        filter="numeric"
                                        filterable={false}
                                        sortable={false}
                                    />
                                    <GridColumn
                                        field="validFrom"
                                        filter="date"
                                        format="{0:d}"
                                        editor="date"
                                        title="Valid From"
                                        cell={(props) => CellRender(props, "Valid From")}
                                        width="90px"
                                        filterable={false}
                                        sortable={false}
                                    />
                                    <GridColumn
                                        field="validTo"
                                        filter="date"
                                        format="{0:d}"
                                        editor="date"
                                        title="Valid To"
                                        cell={(props) => CellRender(props, "Valid To")}
                                        width="90px"
                                        filterable={false}
                                        sortable={false}
                                    />
                                    <GridColumn sortable={false} field="expanded" width="90px" title="View More" cell={this.ExpandCell} />
                                </Grid>
                            </div>
                            <div className="row mb-2 mb-lg-4 ml-0 mr-0">
                                <div className="col-12 text-center text-right font-regular">
                                    <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={() => this.props.handleClose()}>
                                        <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} />
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}
